import axios from "axios";

import Config from "src/config";

const v2_actionExcluirCampanhaRastreamento = (clienteId, campanhaId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/marketing/campanhas-rastreamento/${campanhaId}`
    });
};

export default v2_actionExcluirCampanhaRastreamento;
